import { render, staticRenderFns } from "./SrListItemIcon.vue?vue&type=template&id=4aebd1f6"
import script from "./SrListItemIcon.vue?vue&type=script&lang=js"
export * from "./SrListItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports